import {combineReducers} from '@modifi/redux'
import sellerTradePartnerReducer from './store'
import stepsReducer from './steps-reducer'

export default combineReducers({
  currentStep: stepsReducer,
  form: sellerTradePartnerReducer,
})
